import { CallReason } from './callTypes';

type AuthShutdownReason = Extract<CallReason, 'LOGOUT' | 'WORKSPACE_SWITCH'>;
const owners = new Set<(reason: AuthShutdownReason) => void>();
export function registerCallShutdown(shutdown: (reason: AuthShutdownReason) => void) {
  owners.add(shutdown);
  return () => { owners.delete(shutdown); };
}
/** Called synchronously before credentials or workspace are replaced. */
export function shutdownCalls(reason: AuthShutdownReason) { owners.forEach(shutdown => shutdown(reason)); }
